import clsx from 'clsx';
import React, { Dispatch, SetStateAction } from 'react';

import { useAppContext } from '../../../contexts/AppContext';
import { useCommentActions, useCurrentUser } from '../../../hooks';
import { edit_community_comment_path } from '../../../routes';
import { Comment as CommentType } from '../../../utils/backend-api/comments';
import LikesCount from '../../Forum/LikesCount';
import { TimeAgo } from '../../shared';
import styles from './styles.module.scss';

export default function CommentActions({
  comment,
  setReplyingTo,
  onEditComment,
}: {
  comment: CommentType;
  setReplyingTo: Dispatch<SetStateAction<string>>;
  onEditComment: () => void;
}) {
  const { env } = useAppContext();
  const { currentUser } = useCurrentUser();
  const { report, toggleLike, liked, likesCount, areLikesLoading } = useCommentActions(comment);

  const handleReply = () => {
    setReplyingTo(comment.user.username);
  };

  const LikeButtonJSX = ({ children }: { children: JSX.Element | string }) => {
    return (
      <>
        {!env.READ_ONLY_MODE && currentUser?.permitted_to_comment && (
          <button
            onClick={toggleLike}
            className="comment-action --like unstyled"
            disabled={areLikesLoading}
            title={liked ? 'Unlike' : 'Like'}
          >
            {children}
          </button>
        )}
      </>
    );
  };

  return (
    <div className={styles.commentActions}>
      <LikeButtonJSX>{liked ? 'Unlike' : 'Like'}</LikeButtonJSX>
      {!env.READ_ONLY_MODE && currentUser?.permitted_to_comment && <div className="action-dot" />}

      {currentUser?.permitted_to_comment && (
        <>
          <button onClick={handleReply} className="comment-action --reply unstyled">
            Reply
          </button>
          <div className="action-dot" />
        </>
      )}

      {currentUser?.id === comment.user.id && (
        <>
          <button onClick={onEditComment} className="comment-action --promote unstyled">
            Edit
          </button>
          <div className="action-dot" />
        </>
      )}

      <button onClick={report} className="comment-action --report unstyled">
        Report
      </button>

      {currentUser?.administrator?.is_active && !comment.promoted && (
        <>
          <div className="action-dot" />
          <a
            href={edit_community_comment_path(comment.id)}
            className="comment-action --promote unstyled"
          >
            Promote/Hide
          </a>
        </>
      )}

      <div className="action-dot" />
      <TimeAgo className="comment-date" date={comment.created_at} />

      <div className={styles.likesCount}>
        <LikeButtonJSX>
          <span
            className={clsx({
              [styles.likesCountLiked]: liked,
            })}
          >
            <LikesCount count={likesCount} commentId={comment.id} />
          </span>
        </LikeButtonJSX>
      </div>
    </div>
  );
}
